import { render } from "./SystemPage.vue?vue&type=template&id=08b58d6f&scoped=true"
import script from "./SystemPage.vue?vue&type=script&lang=js"
export * from "./SystemPage.vue?vue&type=script&lang=js"

import "./SystemPage.vue?vue&type=style&index=0&id=08b58d6f&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b58d6f"]])

export default __exports__